import { combineReducers } from '@reduxjs/toolkit';
import exploreFilters from './explore';

export default combineReducers({
  exploreFilters: exploreFilters.slice.reducer,
});
